import constants from './Constants';

const settings = {
  cameraSettings: [
    70,   // Field of view.
    window.innerWidth/window.innerHeight, // Aspect ratio.
    constants.UD * 1, // Near plane.
    constants.UNIVERSE_RADIUS, // Far plane.
  ],
  cameraPosition: [
    constants.LENGTH_AU * 6, // Distance from the origin.
    0, // Polar angle from y axis.
    0, // Equator angle around y axis.
  ],
  controls: {
    enablePan: false,
    enableZoom: true,
    minDistance: constants.UD, // Closest that the camera can zoom in.
    maxDistance: constants.LENGTH_LY * 30, // Farthest that the camera can zoom out.
  },
  beam: {
    angleDeg: 30, 
    rightAscension: 20.8455588794865,
    declination: -38.1323750095745,
  },
  imgDir: '/v2/images/',
  typography: {
    fontFace: 'Arial',
    fontSize: 128,
    baseColor: 'rgba(255,255,0,1)',
    activeColor: 'rgba(0,255,255,1)',
  },
  timeSecond: 500000, // Ratio between Spacecast time an real time.
};

export default settings;